import React, { useState, useEffect } from 'react';
import Axios from "axios";
import ConsultantLayout from '../commonlayouts/consultantlayout';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import LoadingSpinner from "../helpers/loadingspinner";
import { Button, Modal } from 'react-bootstrap';
import { DeleteFromGoogleDriveVideos } from '../apiconstants/constants';

const SelectedVideos = () => {
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const storedCandidates = JSON.parse(localStorage.getItem('selectedVideos') || '[]');
  const [isLoading, setIsLoading] = useState(false);
  const { register, reset, handleSubmit, control, formState: { errors, isSubmitting } } = useForm();
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  const [showModal,setShowModal] = useState(false)
  const token = localStorage.getItem("jwtToken");

  useEffect(() => {
    if (storedCandidates) {
      setSelectedCandidates(storedCandidates);
    }
  }, []);

  const onSubmit = async (data, e) => {
    console.log(data);
    e.preventDefault();
    reset();
    // setIsLoading(true);
   setShowModal(true)
  }

  const handleConfirmDeactivation = async () => {
    const selectedVideos = selectedCandidates.map(candidate => ({
        guid: candidate.guiID,
        videoUrl: candidate.videoURL
      }));
      const params = {
         "videos": selectedVideos
      };

      console.log(params)
    
      await Axios.put(DeleteFromGoogleDriveVideos.APIURL, params,
        { headers: {   
                 Authorization: `Bearer ${token}`,   
                 "Content-Type": "application/json",  
          }      }
                                                    
      )
       .then((result) => 
         {
           if(result.data=='Deleted successfully'){
             Swal.fire({
               position: 'center',
               icon: 'success',
               title: 'Deleted successfully',
               showConfirmButton: false,
               timer: 2000,
             })
             navigate("/Employer/ListSavedVideos")
           }
         
           else{
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Video not found',
              showConfirmButton: false,
              timer: 2000,
            })
          }
         
 
         setIsLoading(false);
         setShowModal(false);
 
       })
       .catch((error) => {
         console.log("Error" + error);
       });
     }
 
 
 
 const handleCancel = () => {
   setShowModal(false);
 };
 

  return (
    <ConsultantLayout>
      {isLoading ? <center><LoadingSpinner /></center> :
        <div className='container mt-3'>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/Employer/ListSavedVideos">
              <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8 }} aria-hidden="true"></i>
            </Link>
            <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Selected Videos</h2>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {selectedCandidates.map(item => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
         </div>
      }
                <form onSubmit={handleSubmit(onSubmit)} id="loginform">
                <Link to="/Employer/ListSavedVideos">
              <button style={{ float: "right" }} className="btn btn-primary mt-5 ">
                Cancel
              </button>
            </Link>
                <button
              id="svbutton"
              style={{ float: "right" }}
              disabled={isSubmitting || isDisabled}
              className="btn btn-primary pf-save mb-3 mr-3 mt-5"
            >
              Delete
            </button>
</form>
      <Modal show={showModal} style={{textAlign:"center"}} onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#00a7ac"}}>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>No</Button>
          <Button variant="primary" onClick={handleConfirmDeactivation}>Yes</Button>
        </Modal.Footer>
      </Modal>
    </ConsultantLayout>
  );
}

export default SelectedVideos;
